import script from "./TicketSelectionStep.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketSelectionStep.vue?vue&type=script&setup=true&lang=js"

import "./TicketSelectionStep.vue?vue&type=style&index=0&id=12f61539&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f61539"]])

export default __exports__